import React from 'react';
import classnames from 'classnames';
import { styled } from 'react-free-style';

const SortableColumnHeader = ({ text, onClick, direction, styles = {} }) => {
  const sortIconClass = direction ? (direction === 1 ? 'fa-caret-up' : 'fa-caret-down') : 'fa-sort';
  const selectedClass = direction ? styles.selected : styles.notSelected;
  return (
    <span
      id={`sortable-column-${text}`}
      className={styles.clickableHeaderText}
      onClick={() => {
        onClick && onClick(direction ? direction * -1 : 1);
      }}
    >
      {text}
      <i className={classnames('fa', 'fa-w', sortIconClass, selectedClass)} />
    </span>
  );
};
const withStyles = styled({
  notSelected: {
    color: 'silver',
    marginLeft: 5,
  },
  selected: {
    color: 'black',
    marginLeft: 5,
  },
  clickableHeaderText: {
    cursor: 'pointer',
    whiteSpace: 'noWrap',
  },
});

export default withStyles(SortableColumnHeader);
